import { PAGE_URLS, booleanInteger } from "src/app/core/models/general";
import { PaginatedRequest } from "src/models/requests";
import { REPORT_CODE, ReportInfoMap } from "../../../models/constants";

export interface AsyncReport {
  id: number;
  createdAt: string;
  updatedAt: string;
  urls: AsyncReportUrls;
  code: REPORT_CODE;
  status: AsyncReportStatus;
  request: any;
}

export interface AsyncReportUrls {
  status: string;
  export: string;
  records: string;
}

export enum AsyncReportStatus {
  IN_PROCESS = "in_process",
  GENERATED = "generated",
  CREATED = "created",
  FAILED = "failed",
}

export function getAsyncReportUrl(code: REPORT_CODE) {
  let url = "";
  ReportInfoMap.forEach((report) => {
    if (report.code === code && report.isVisible) {
      url = `${PAGE_URLS.REPORTING_VIEW}/${report.id}`;
    }
  });
  return url;
}

export interface DateRangeRequest {
  from: string;
  to: string;
}

export interface AsyncReportBaseRequest extends PaginatedRequest {
  new: booleanInteger;
}
